import React from "react";
import { FormConcluedProvider } from "../provider/FormConcluedProvider";
import { ContainerConcluedModal } from "./ContainerConcluedModal";


export const FormConcludedComments = ({ disableIputs = false, project, auth, activeModalDetailsProject, updateProject, closeModalDetails }) => {


    return (
        <FormConcluedProvider
            closeModalDetails={closeModalDetails}
            project={project}
            auth={auth}
            updateProject={updateProject}
            disableIputs={disableIputs}
            activeModalDetailsProject={activeModalDetailsProject}
        >
            <ContainerConcluedModal disableIputs={disableIputs} />
        </FormConcluedProvider>
    )
}
